//Commmon
import { fn_hexToHsla } from "@/common/utils/color";

//Util
import {
  PATH_DEMONSTRACAO,
  PATH_FERRAMENTA_ADM_SYSTEM,
  TEMA_DEMONSTRACAO,
  TEMA_PADRAO,
  TEMA_SYSTEM,
} from "@/common/constantes";
import { fn_ambienteIsDesenvolvimento } from "./env";

/*
 * Retorna o tema do tenant
 */
export function fn_getTemaTenant(path) {
  const isDev = fn_ambienteIsDesenvolvimento();

  return path == PATH_DEMONSTRACAO || isDev
    ? TEMA_DEMONSTRACAO
    : path == PATH_FERRAMENTA_ADM_SYSTEM
      ? TEMA_SYSTEM
      : TEMA_PADRAO;
}

/*
 * Substitui o tema padrão do sistema pelo tema passado como parâmetro
 */
export function fn_aplicarTema(tema) {
  document.body.classList.add("Tema-siig");

  document.body.classList.toggle(
    "striped",
    tema.table_striped == "S" ? true : false,
  );

  document.documentElement.style.setProperty(
    "--opacity",
    fn_hexToHsla(tema.header_footer_background, 0.2),
  );

  document.documentElement.style.setProperty(
    "--header-footer-background",
    tema.header_footer_background,
  );

  document.documentElement.style.setProperty(
    "--header-footer-color",
    tema.header_footer_color,
  );

  document.documentElement.style.setProperty("--title-color", tema.title_color);

  document.documentElement.style.setProperty(
    "--table-header-background",
    tema.table_header_background,
  );

  document.documentElement.style.setProperty(
    "--table-header-color",
    tema.table_header_color,
  );

  document.documentElement.style.setProperty(
    "--primary-background",
    tema.primary_background,
  );

  document.documentElement.style.setProperty(
    "--primary-background-opacity",
    fn_hexToHsla(tema.primary_background, 0.7),
  );

  document.documentElement.style.setProperty(
    "--primary-background-shadow",
    fn_hexToHsla(tema.primary_background, 0.5),
  );

  document.documentElement.style.setProperty(
    "--primary-color",
    tema.primary_color,
  );

  document.documentElement.style.setProperty(
    "--secondary-background",
    tema.secondary_background,
  );

  document.documentElement.style.setProperty(
    "--secondary-color",
    tema.secondary_color,
  );
}
